import { useLayoutEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { Layout } from "./components/layout";
import { Logout } from "./components/logout";
import { ControlActivate } from "./pages/control/activate";
import { ControlAssociationCreate } from "./pages/control/association-create";
import { ControlAssociationEdit } from "./pages/control/association-edit";
import { ControlInviteAccept } from "./pages/control/invite-accept";
import { ControlLogin } from "./pages/control/login";
import { ControlRegister } from "./pages/control/register";
import { ControlResetPassword } from "./pages/control/reset-password";
import { ControlStart } from "./pages/control/start";
import { Users } from "./pages/control/users";
import { useAuthStore } from "./stores/auth";
import { useControlAssociationStore } from "./stores/control-association";
import { useLocale } from "./stores/locale";

export function ControllApp() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { locale } = useLocale();
  const { isAuth } = useAuthStore();
  const selectedAssociationId = useControlAssociationStore(
    (s) => s.selectedAssociationId,
  );

  useLayoutEffect(() => {
    if (pathname !== "/") {
      return;
    }

    if (!isAuth) {
      navigate("/login", { replace: true });
      return;
    }

    if (!selectedAssociationId) {
      navigate("/start", { replace: true });
      return;
    }

    navigate("/admin/users", { replace: true });
  }, [pathname, isAuth, selectedAssociationId, navigate]);

  const menu = [
    ...(!isAuth
      ? [
          { slug: "/login", title: locale.login.title },
          { slug: "/register", title: locale.auth.registerTitle },
        ]
      : []),
    ...(isAuth && !selectedAssociationId
      ? [{ slug: "/start", title: locale.auth.controlStartMenu }]
      : []),
    ...(isAuth && selectedAssociationId
      ? [{ slug: "/admin/users", title: locale.auth.adminUsersTitle }]
      : []),
  ];

  return (
    <Layout
      color="blue"
      menu={menu}
      name="Boark"
      profileMenu={
        isAuth
          ? [
              ...(selectedAssociationId
                ? [
                    {
                      slug: "/start",
                      title: locale.auth.controlStartChangeAssociation,
                    },
                  ]
                : []),
              {
                slug: "/logout",
                title: locale.logout,
              },
            ]
          : undefined
      }
      showSearch={false}
    >
      <Routes>
        <Route element={<ControlStart />} path="/start" />
        <Route
          element={<ControlAssociationCreate />}
          path="/association/create"
        />
        <Route
          element={<ControlAssociationEdit />}
          path="/association/:id/edit"
        />
        <Route element={<ControlLogin />} path="/login" />
        <Route element={<ControlRegister />} path="/register" />
        <Route element={<ControlActivate />} path="/activate" />
        <Route element={<ControlResetPassword />} path="/reset-password" />
        <Route element={<ControlInviteAccept />} path="/invite/accept" />
        <Route element={<Users />} path="/admin/users" />
        <Route element={<Logout />} path="/logout" />
      </Routes>
    </Layout>
  );
}
